import { render, staticRenderFns } from "./PortalTemplate.vue?vue&type=template&id=1ffb0e7a"
import script from "./PortalTemplate.ts?vue&type=script&lang=ts"
export * from "./PortalTemplate.ts?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.0.10@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports